// Curated icon list for sub-categories
import {
  IconTractor,
  IconBackhoe,
  IconScissors,
  IconCar,
  IconBike,
  IconTruck,
  IconTruckDelivery,
  IconBuildingFactory2,
  IconDroplet,
  IconLeaf,
  IconPlant2,
  IconBolt,
  IconFlame,
  IconCircle,
  IconSquare,
  IconRectangle,
  IconWand,
  IconTool,
  IconBox,
  IconPackage,
  IconBrandTabler,
} from '@tabler/icons-react';

export const ICON_OPTIONS = [
  { name: 'IconTractor',      label: 'Tractor',           Component: IconTractor },
  { name: 'IconBackhoe',      label: 'Backhoe',           Component: IconBackhoe },
  { name: 'IconScissors',     label: 'Mower',             Component: IconScissors },
  { name: 'IconBike',         label: 'Quad / Bike',       Component: IconBike },
  { name: 'IconCar',          label: 'Car',               Component: IconCar },
  { name: 'IconTruck',        label: 'Truck',             Component: IconTruck },
  { name: 'IconTruckDelivery',label: 'Van',               Component: IconTruckDelivery },
  { name: 'IconDroplet',      label: 'Sprayer / Liquid',  Component: IconDroplet },
  { name: 'IconLeaf',         label: 'Leaf / Crop',       Component: IconLeaf },
  { name: 'IconPlant2',       label: 'Plant / Seed',      Component: IconPlant2 },
  { name: 'IconBolt',         label: 'Power',             Component: IconBolt },
  { name: 'IconFlame',        label: 'Fuel',              Component: IconFlame },
  { name: 'IconBox',          label: 'Box',               Component: IconBox },
  { name: 'IconPackage',      label: 'Package',           Component: IconPackage },
  { name: 'IconTool',         label: 'Tool',              Component: IconTool },
  { name: 'IconWand',         label: 'Wand',              Component: IconWand },
  { name: 'IconCircle',       label: 'Circle',            Component: IconCircle },
  { name: 'IconSquare',       label: 'Square',            Component: IconSquare },
  { name: 'IconRectangle',    label: 'Rectangle',         Component: IconRectangle },
  { name: 'IconBuildingFactory2', label: 'Factory',       Component: IconBuildingFactory2 },
  { name: 'IconBrandTabler',  label: 'Default',           Component: IconBrandTabler },
];

export const getIconByName = (name) => {
  return ICON_OPTIONS.find(i => i.name === name)?.Component || IconBuildingFactory2;
};
